import { loadDictionary } from './locales/tr';

loadDictionary()
  .catch((err) => console.error(err))
  .finally(() => import(/* webpackMode: "eager" */ './root'));
